// src/components/BoardOfEd/components/Program3200.jsx
import React from "react";
import { ProgramBudget } from "../../../../budget/model/program/ProgramBudget.jsx";

export const PROGRAM_3200_CONFIG = {
  fullName: "SECONDARY OPERATIONS 7-12",
  docId: "3200",

  fieldDefs: [
    // POSITIONS (FTE)
    {
      key: "positionsAdmin",
      label: "Positions – Administrative",
      valueType: "count",
      sources: [{ block: "Positions", key: "Administrative" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecretarial",
      label: "Positions – Secretarial",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secretarial" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsParaeducators",
      label: "Positions – Paraeducators",
      valueType: "count",
      sources: [{ block: "Positions", key: "Paraeducators" }],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsIssMonitor",
      label: "Positions – In-School Suspension Monitor",
      valueType: "count",
      sources: [
        { block: "Positions", key: "In-School Suspension Monitor" },
        { block: "Positions", key: "In-School Suspension Monitor " },
      ],
      group: "positions",
      defaultVisible: false,
    },
    {
      key: "positionsSecondaryStaffing",
      label: "Positions – Secondary Staffing",
      valueType: "count",
      sources: [{ block: "Positions", key: "Secondary Staffing" }],
      group: "positions",
      defaultVisible: false,
    },

    // SALARIES
    {
      key: "salariesAdmin",
      label: "Salaries – Administrative",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Administrative" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecretarial",
      label: "Salaries – Secretarial",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secretarial" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesParaeducators",
      label: "Salaries – Paraeducators",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Paraeducators" }],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesIssMonitor",
      label: "Salaries – In-School Suspension Monitor",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "In-School Suspension Monitor" },
        { block: "Salaries", key: "In-School Suspension Monitor " },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSaturdayProgram",
      label: "Salaries – Saturday Program (GHS)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Saturday Program (GHS)" },
        { block: "Salaries", key: "Saturday Program (GHS) " },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSaturdaySchoolSmith",
      label: "Salaries – Saturday School Supervision (Smith)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Saturday School Supervision (Smith)" },
        { block: "Salaries", key: "Saturday School Supv. (Smith)" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesTeamLeadersSmith",
      label: "Salaries – Team Leaders (Smith)",
      valueType: "currency",
      sources: [
        { block: "Salaries", key: "Team Leaders (Smith)" },
        { block: "Salaries", key: "Team Leaders Stipends (GW)" },
      ],
      group: "salaries",
      defaultVisible: false,
    },
    {
      key: "salariesSecondaryStaffing",
      label: "Salaries – Secondary Staffing",
      valueType: "currency",
      sources: [{ block: "Salaries", key: "Secondary Staffing" }],
      group: "salaries",
      defaultVisible: false,
    },

    // PURCHASED SERVICES
    {
      key: "printing",
      label: "Printing",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Printing" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "mandatedTesting",
      label: "Mandated Student Testing",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Mandated Student Testing" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "culturalArtsGhs",
      label: "Cultural Arts / GHS",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "Cultural Arts / GHS" },
        { block: "Purchased Services", key: "Cultural Arts/GHS" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "schoolClimateSmith",
      label: "School Climate / Smith",
      valueType: "currency",
      sources: [
        { block: "Purchased Services", key: "School Climate / Smith" },
        { block: "Purchased Services", key: "School Climate/Smith" },
      ],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "neascEvaluations",
      label: "NEASC Evaluations",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "NEASC Evaluations" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "copiers",
      label: "Copiers",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Copiers" }],
      group: "services",
      defaultVisible: false,
    },
    {
      key: "secondaryMagnet",
      label: "Secondary Magnet",
      valueType: "currency",
      sources: [{ block: "Purchased Services", key: "Secondary Magnet" }],
      group: "services",
      defaultVisible: false,
    },

    // SUPPLIES / MATERIALS
    {
      key: "supplies",
      label: "Supplies",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Supplies" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "publications",
      label: "Publications",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Publications" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "graduationExpenses",
      label: "Graduation Expenses",
      valueType: "currency",
      sources: [{ block: "Supplies / Materials", key: "Graduation Expenses" }],
      group: "materials",
      defaultVisible: false,
    },
    {
      key: "schoolFunctionCosts",
      label: "School Function Costs",
      valueType: "currency",
      sources: [
        { block: "Supplies / Materials", key: "School Function Costs" },
      ],
      group: "materials",
      defaultVisible: false,
    },

    // OTHER
    {
      key: "travelReimbursement",
      label: "Travel Reimbursement",
      valueType: "currency",
      sources: [{ block: "Other", key: "Travel Reimbursement" }],
      group: "other",
      defaultVisible: false,
    },
    {
      key: "associationDues",
      label: "N.E. & CT Association Dues",
      valueType: "currency",
      sources: [
        { block: "Other", key: "N.E. & CT Association Dues" },
        { block: "Other", key: "NE & CT Association Dues" },
      ],
      group: "other",
      defaultVisible: false,
    },
  ],

  tables: [
    {
      id: "approved",
      title: "Approved Budget",
      sectionKey: "Approved",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSecretarial",
        "positionsParaeducators",
        "positionsIssMonitor",
        "positionsSecondaryStaffing",

        // Salaries
        "salariesAdmin",
        "salariesSecretarial",
        "salariesParaeducators",
        "salariesIssMonitor",
        "salariesSaturdayProgram",
        "salariesSaturdaySchoolSmith",
        "salariesTeamLeadersSmith",
        "salariesSecondaryStaffing",

        // Purchased Services
        "printing",
        "mandatedTesting",
        "culturalArtsGhs",
        "schoolClimateSmith",
        "neascEvaluations",
        "copiers",
        "secondaryMagnet",

        // Supplies / Materials
        "supplies",
        "publications",
        "graduationExpenses",
        "schoolFunctionCosts",

        // Other
        "travelReimbursement",
        "associationDues",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsSecretarial: { minWidth: "110px" },
        positionsParaeducators: { minWidth: "120px" },
        positionsIssMonitor: { minWidth: "180px" },
        positionsSecondaryStaffing: { minWidth: "150px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesSecretarial: { minWidth: "130px" },
        salariesParaeducators: { minWidth: "130px" },
        salariesIssMonitor: { minWidth: "190px" },
        salariesSaturdayProgram: { minWidth: "170px" },
        salariesSaturdaySchoolSmith: { minWidth: "210px" },
        salariesTeamLeadersSmith: { minWidth: "170px" },
        salariesSecondaryStaffing: { minWidth: "150px" },

        // Purchased Services
        printing: { minWidth: "90px" },
        mandatedTesting: { minWidth: "150px" },
        culturalArtsGhs: { minWidth: "120px" },
        schoolClimateSmith: { minWidth: "120px" },
        neascEvaluations: { minWidth: "100px" },
        copiers: { minWidth: "100px" },
        secondaryMagnet: { minWidth: "100px" },

        // Supplies / Materials
        supplies: { minWidth: "90px" },
        publications: { minWidth: "105px" },
        graduationExpenses: { minWidth: "100px" },
        schoolFunctionCosts: { minWidth: "130px" },

        // Other
        travelReimbursement: { minWidth: "130px" },
        associationDues: { minWidth: "140px" },
      },
    },
    {
      id: "actual",
      title: "Actual Spending",
      sectionKey: "Actual",
      fields: [
        // Positions
        "positionsAdmin",
        "positionsSecretarial",
        "positionsParaeducators",
        "positionsIssMonitor",
        "positionsSecondaryStaffing",

        // Salaries
        "salariesAdmin",
        "salariesSecretarial",
        "salariesParaeducators",
        "salariesIssMonitor",
        "salariesSaturdayProgram",
        "salariesSaturdaySchoolSmith",
        "salariesTeamLeadersSmith",
        "salariesSecondaryStaffing",

        // Purchased Services
        "printing",
        "mandatedTesting",
        "culturalArtsGhs",
        "schoolClimateSmith",
        "neascEvaluations",
        "copiers",
        "secondaryMagnet",

        // Supplies / Materials
        "supplies",
        "publications",
        "graduationExpenses",
        "schoolFunctionCosts",

        // Other
        "travelReimbursement",
        "associationDues",
      ],
      columnStyles: {
        year: { width: "100px", minWidth: "100px" },

        // Positions
        positionsAdmin: { minWidth: "120px" },
        positionsSecretarial: { minWidth: "110px" },
        positionsParaeducators: { minWidth: "120px" },
        positionsIssMonitor: { minWidth: "180px" },
        positionsSecondaryStaffing: { minWidth: "150px" },

        // Salaries
        salariesAdmin: { minWidth: "130px" },
        salariesSecretarial: { minWidth: "130px" },
        salariesParaeducators: { minWidth: "130px" },
        salariesIssMonitor: { minWidth: "190px" },
        salariesSaturdayProgram: { minWidth: "170px" },
        salariesSaturdaySchoolSmith: { minWidth: "210px" },
        salariesTeamLeadersSmith: { minWidth: "170px" },
        salariesSecondaryStaffing: { minWidth: "150px" },

        // Purchased Services
        printing: { minWidth: "90px" },
        mandatedTesting: { minWidth: "150px" },
        culturalArtsGhs: { minWidth: "120px" },
        schoolClimateSmith: { minWidth: "120px" },
        neascEvaluations: { minWidth: "100px" },
        copiers: { minWidth: "100px" },
        secondaryMagnet: { minWidth: "100px" },

        // Supplies / Materials
        supplies: { minWidth: "90px" },
        publications: { minWidth: "105px" },
        graduationExpenses: { minWidth: "100px" },
        schoolFunctionCosts: { minWidth: "130px" },

        // Other
        travelReimbursement: { minWidth: "130px" },
        associationDues: { minWidth: "140px" },
      },
    },
  ],
};

export function Program3200(props) {
  return (
    <ProgramBudget programId="3200" config={PROGRAM_3200_CONFIG} {...props} />
  );
}
